import { _decorator, Component, Node, Button } from 'cc';
import Lobby from '../../../System/Lobby';
import MachineRecord from '../GameObject/History/MachineRecord/MachineRecord';
import MachineRecordList from '../GameObject/History/MachineRecordList';
import HistoryRecordList from '../GameObject/History/HistoryRecordList';
import Page from '../../../../common/scripts/Toolkit/Components/Page/Page';
import Dropdown from '../../../../common/scripts/Toolkit/Components/Dropdown/Dropdown';
import MultiThemeSource from '../../../../common/scripts/Toolkit/Components/MultiTheme/MultiThemeSource';
import { TimeRangeOption } from '../../../../tableEngine/Script/Game/UI/TimeRangeDropdown';
import DataType from '../../../../tableEngine/Script/Game/Data/Config/DataStructure';
import IHistoryData from '../../../../tableEngine/Script/Game/Data/DataObject/History/IHistoryData';

const { ccclass, property, requireComponent } = _decorator;

const MACHINE_THEME = 0;
const GAME_RECORD_THEME = 1;

enum EventType {
    ENTER_MACHINE_FROM_HISTORY = 'ENTER_MACHINE_FROM_HISTORY',
}

@ccclass('HistoryPage')
@requireComponent([Page, MultiThemeSource])
export default class HistoryPage extends Component {
    public static readonly EVENT_TYPE = EventType;

    @property(MachineRecordList)
    private readonly machineRecordList: MachineRecordList = null;

    @property(HistoryRecordList)
    private readonly historyRecordList: HistoryRecordList = null;

    @property(Dropdown)
    private readonly timeRangeDropdown: Dropdown<TimeRangeOption> = null;

    @property(Dropdown)
    private readonly playTypeDropdown: Dropdown<DataType.Enums.PlayType> = null;

    @property(Node)
    private readonly noRecordHint: Node = null;

    @property(Node)
    private readonly loadingMark: Node = null;

    @property(Button)
    private readonly backButton: Button = null;

    private _page: Page = null;
    private _layout: MultiThemeSource = null;

    private get page() {
        if (!this._page) {
            this._page = this.getComponent(Page);
        }
        return this._page;
    }

    private get layout() {
        if (!this._layout) {
            this._layout = this.getComponent(MultiThemeSource);
        }
        return this._layout;
    }

    public onLoad() {
        this.machineRecordList.init(this.noRecordHint, this.loadingMark);
        this.historyRecordList.init(this.noRecordHint, this.loadingMark);
        this.machineRecordList.on(MachineRecord.EVENT_TYPE.ENTER_MACHINE, this._enterMachine, this);
        this.machineRecordList.on(MachineRecord.EVENT_TYPE.OPEN_MACHINE_RECORD_LIST, this._openHistoryRecordList, this);
        this.timeRangeDropdown.on(Dropdown.EVENT_TYPE.SELECTED_OPTION_CHANGED, this._updateQueryTimeRange, this);
        this.playTypeDropdown.on(Dropdown.EVENT_TYPE.SELECTED_OPTION_CHANGED, this._updateQueryGameType, this);
        this.backButton.on(Button.EventType.CLICK, this._closeCurrentView, this);
        this.page.on(Page.EVENT_TYPE.OPEN_START, this._onPageOpen, this);
        this.page.on(Page.EVENT_TYPE.CLOSE_END, this._closeGameRecord, this);
    }

    private _enterMachine(tableID: string) {
        Lobby.event.emit(EventType.ENTER_MACHINE_FROM_HISTORY, tableID);
    }

    private _onPageOpen() {
        // check sync state every time page is opened
        Lobby.history.updateQueryEndTime();
        this._openMachineRecordList();
    }

    private _openMachineRecordList() {
        this.layout.theme = MACHINE_THEME;
    }

    private _openHistoryRecordList(data: IHistoryData) {
        this.historyRecordList.updateDisplayHistoryInfo(data.machineName, data.machineID);
        this.historyRecordList.displayJackpot = false;

        this._openGameRecord();
    }

    private _updateQueryTimeRange() {
        Lobby.history.updateQueryTimeRange(this.timeRangeDropdown.selectedOptionValue);
    }

    private _updateQueryGameType() {
        Lobby.history.updateGameType(this.playTypeDropdown.selectedOptionValue);
    }

    private _openGameRecord() {
        this.layout.theme = GAME_RECORD_THEME;
    }

    private _closeGameRecord() {
        this.layout.theme = MACHINE_THEME;
    }

    private _closeCurrentView() {
        if (this.layout.theme === GAME_RECORD_THEME) {
            this._closeGameRecord();
        } else {
            this.page.close();
        }
    }
}
